// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text, Sprite } from 'pixi.js';
import { RaceEventBigCarLayout } from './RaceEventBigCarLayout';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: 'd5dda5bf-c299-4a57-be4e-8249c6f241df',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'e87c0f21-61ea-479c-8863-709e3429cdaf',
      type: 'Text',
      name: '',
      className: 'colorTags_SPL',
      x: 0,
      y: 806,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Get *rewards* by reaching \\n a *level the fastest*!',
      localize: true,
      maxWidth: 775,
      maxHeight: 160,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 556,
        breakWords: false,
        lineHeight: 43,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd5dda5bf-c299-4a57-be4e-8249c6f241df',
      data: {
        colorTags: {
          '*': '#52defa'
        }
      }
    },
    {
      id: '555b7699-3c97-43b3-a7a9-2cd1da0bad2a',
      type: 'Container',
      name: 'smokeContainer',
      className: '',
      x: -246,
      y: 402,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd5dda5bf-c299-4a57-be4e-8249c6f241df'
    },
    {
      id: 'ae914748-786e-44e6-8293-acad63f22948',
      type: 'Layout',
      name: 'carLayout',
      className: '',
      path: 'raceEvent/RaceEventBigCarLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: -162,
      y: 432,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'd5dda5bf-c299-4a57-be4e-8249c6f241df'
    },
    {
      id: '9445c291-f376-4855-a328-847b33b22a10',
      type: 'Container',
      name: 'trophyGroup',
      className: '',
      x: 207,
      y: 508,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd5dda5bf-c299-4a57-be4e-8249c6f241df'
    },
    {
      id: '2bb9a3fd-d0d3-4657-9240-cf0aefb912b2',
      type: 'Layout',
      name: 'joinButton',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 1043,
      scale: {
        x: 1.2,
        y: 1.2
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      parent: 'd5dda5bf-c299-4a57-be4e-8249c6f241df',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '0d528e2d-a1b7-4631-834f-ade17c42fcda',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: 38,
      y: -131,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16709525,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '796c43f4-700c-4ed3-bd34-7ad48dde086d',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: 38,
      y: -131,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16709525,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'a123477e-097a-4768-8417-760957ee941c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 42,
      y: -42,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_6',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'fb3d3323-8437-486c-acde-15e50631b5bc',
      type: 'Sprite',
      name: '',
      className: '',
      x: 38,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Chests_Podium_Join_Screen',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '392c08c6-0321-4ee1-a85d-2a26ec2de6c4',
      type: 'Sprite',
      name: '',
      className: '',
      x: 94,
      y: -13,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '74535773-01c6-4ad3-8b2c-4f32a337a1f8',
      type: 'Sprite',
      name: '',
      className: '',
      x: 10,
      y: -17,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_4',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '9cf3042a-1d82-491d-a25f-da93cb6eb467',
      type: 'Sprite',
      name: '',
      className: '',
      x: -63,
      y: -17,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_3',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'e7b11e57-839e-4059-a21e-8937a3d812f9',
      type: 'Sprite',
      name: '',
      className: '',
      x: -62,
      y: 24,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_6',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '99ff5dea-7daa-4466-b0f7-66c11d5e1cf6',
      type: 'Sprite',
      name: '',
      className: '',
      x: -229,
      y: 74,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_6',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '7bc41fc3-bc72-492f-8828-6353ea84cc9a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 31,
      y: -124,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Chest_Gold_Open',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '266dfbb3-1cf1-4e8e-996a-9316513a27a1',
      type: 'Sprite',
      name: '',
      className: '',
      x: -82,
      y: 129,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Chests_Podium_Join_Screen',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'baad7146-76e0-403b-89da-23b9c3c0ca0d',
      type: 'Sprite',
      name: '',
      className: '',
      x: -214,
      y: 120,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'edcdcf70-2548-4cc8-9158-7abea3949c24',
      type: 'Sprite',
      name: '',
      className: '',
      x: -113,
      y: 144,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'd44d6be5-c8e8-41fa-8416-6a2096004c63',
      type: 'Sprite',
      name: '',
      className: '',
      x: -138,
      y: 134,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_4',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '70975ab7-4367-4603-9411-f1f1a934ac6f',
      type: 'Sprite',
      name: '',
      className: '',
      x: -35,
      y: 84,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_4',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'aa254b57-8908-45e8-86ab-e0f9795e32d1',
      type: 'Sprite',
      name: '',
      className: '',
      x: -48,
      y: 142,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -0.2,
        y: 0.2
      },
      angle: 18,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Swap_Booster',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'c73fe725-585c-441f-92dc-47161f7d220a',
      type: 'Sprite',
      name: '',
      className: '',
      x: -85,
      y: 136,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_6',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '37663fea-14ce-4306-8240-587ce20dbdb3',
      type: 'Sprite',
      name: '',
      className: '',
      x: 91,
      y: 88,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_3',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'c5016b14-18cd-4fc2-8095-ef93eebaa611',
      type: 'Sprite',
      name: '',
      className: '',
      x: -61,
      y: 194,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -0.2,
        y: 0.2
      },
      angle: 18,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Big_New',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '88184d10-488b-4c32-b404-4242dccbce66',
      type: 'Sprite',
      name: '',
      className: '',
      x: -60,
      y: 190,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -0.2,
        y: 0.2
      },
      angle: 18,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Infinity',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'e53dadf0-3b0c-4541-821d-8fbc12c636b3',
      type: 'Sprite',
      name: '',
      className: '',
      x: 71,
      y: 163,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Chests_Podium_Join_Screen',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'd496a709-07b2-4689-9168-a700573ac520',
      type: 'Sprite',
      name: '',
      className: '',
      x: -79,
      y: 16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Chest_Silver_Open',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'f776ecb7-406a-4119-b6ba-724a34418dc4',
      type: 'Sprite',
      name: '',
      className: '',
      x: 82,
      y: 63,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Chest_Bronze_Open',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'd0a11db4-e14e-42f9-9758-3fdf07dce6b3',
      type: 'Sprite',
      name: '',
      className: '',
      x: -53,
      y: 158,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_3',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '9f433fa7-f9bc-4913-871e-144719368c1f',
      type: 'Sprite',
      name: '',
      className: '',
      x: 123,
      y: 144,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'bc6b242f-76d1-49d7-8126-bf4a7b30aa27',
      type: 'Sprite',
      name: '',
      className: '',
      x: 152,
      y: 197,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Undo_Booster',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'd22553e9-11a1-43f0-8011-e27bbaeb4cd5',
      type: 'Sprite',
      name: '',
      className: '',
      x: 48,
      y: 171,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_2',
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '5e84b747-086e-49f5-8dfa-6fb34267b033',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: 52,
      y: -128,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '000c4159-07c6-4b79-a811-921080cc3e7c',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: -69,
      y: 3,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '90e6d8d7-0460-4acd-a4f4-c12fa1f01c20',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: 15,
      y: -194,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'ab79c4db-8d42-488d-b225-6acc13798e26',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: 159,
      y: -29,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '5d7b09e7-f9b8-4245-af88-305c9ff4a088',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: 69,
      y: 63,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '52f4726c-5a06-4a73-93db-9256668bad53',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: -35,
      y: 149,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'fcfce88e-359c-4d8e-981f-e38c7035c309',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: 197,
      y: 149,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '0b85ffbd-fb6e-4b66-96c9-f8e989cc3dfb',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: -174,
      y: 126,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '2eca6f84-c6cc-475f-9963-9d24e8949fff',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: -85,
      y: 163,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '180bf72e-3d9f-4f1f-ab98-a9aa1226c590',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: -100,
      y: -42,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '51bf9f62-42ac-4827-992c-a8cbda0e106a',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: 79,
      y: 10,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '566d11a0-bd05-4553-8240-c7e2816ec75c',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: 198,
      y: 147,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: 'de4527b0-8055-49e5-b816-0fc49c55b3da',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: -200,
      y: 117,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '88f4d73e-c218-46c0-ad3d-cf8a62b5552f',
      type: 'Container',
      name: '',
      className: 'shine_SPL',
      x: 170,
      y: -9,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9445c291-f376-4855-a328-847b33b22a10'
    },
    {
      id: '101b078b-3ce8-48ac-8961-4bb0cf58b863',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.83,
        y: 0.83
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Join',
      localize: true,
      maxWidth: 433,
      maxHeight: 110,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 70,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#24631E',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#24631E',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '2bb9a3fd-d0d3-4657-9240-cf0aefb912b2'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  animations: [
    {
      id: '1172a5dd-9779-403c-bf3d-9c5a1939f13a',
      name: 'Trophy_Idle',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: '337521dd-ec40-47bc-a8ab-3c9c4a0cb615',
          type: 'Tween',
          name: 'trophy_1_copy_1',
          duration: 1000,
          track: 1,
          target: {
            anchor: {},
            scale: {
              x: 1.01,
              y: 1.01
            }
          },
          startAt: 0,
          sourceName: 'trophyGroup',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '2702688c-18e9-4221-a2f4-351962d01d64',
          type: 'Tween',
          name: 'trophy_1_copy_copy',
          duration: 1000,
          track: 1,
          target: {
            anchor: {},
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1000,
          sourceName: 'trophyGroup',
          easing: 'SinusoidalInOut',
          disabled: false
        }
      ]
    },
    {
      id: '021af930-a9ef-4dee-9ade-68dc3d3b40fe',
      name: 'Smoke_Animation',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '31f445a9-f267-478f-9673-eadec30fe558',
          type: 'Setter',
          name: 'FXPART_Race_Event_Smoke_Particles_Join_Screen',
          track: 1,
          target: {},
          startAt: 0,
          sourceName: 'smokeContainer',
          disabled: false
        }
      ]
    },
    {
      id: '0e95eceb-c949-4f6d-b114-0763ef0d33c4',
      name: 'Button_Idle',
      playingSpeed: 1,
      totalDuration: 2500,
      blocks: [
        {
          id: '64898c48-92c2-4b66-849f-0051c2a5a924',
          type: 'Tween',
          name: 'New_tween',
          duration: 250,
          track: 2,
          target: {
            scale: {
              x: 1.3,
              y: 1.3
            }
          },
          startAt: 0,
          sourceName: 'joinButton',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '7ab9695c-009e-44c1-aca3-a877c179a688',
          type: 'Tween',
          name: 'New_tween_copy',
          duration: 250,
          track: 2,
          target: {
            scale: {
              x: 1.2,
              y: 1.2
            }
          },
          startAt: 250,
          sourceName: 'joinButton',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: 'dc000a9e-20b6-4465-86da-d88c7119af03',
          type: 'Tween',
          name: 'New_tween_copy_1',
          duration: 250,
          track: 2,
          target: {
            scale: {
              x: 1.3,
              y: 1.3
            }
          },
          startAt: 500,
          sourceName: 'joinButton',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '625bb96a-fa4d-443b-844c-b90c619b0aab',
          type: 'Tween',
          name: 'New_tween_copy_copy',
          duration: 400,
          track: 2,
          target: {
            scale: {
              x: 1.2,
              y: 1.2
            }
          },
          startAt: 750,
          sourceName: 'joinButton',
          easing: 'SinusoidalOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class RaceEventJoinLayout {
  static raw = raw;
  root!: Container;
  smokeContainer!: Container;
  carLayout!: RaceEventBigCarLayout;
  trophyGroup!: Container;
  joinButton!: ButtonExtraLargeLayout & { data: typeof raw['list'][5]['data'] };
  colorTags_SPL!: (Text & { data: typeof raw['list'][1]['data'] })[];
  rotate_SPL!: (Sprite)[];
  shine_SPL!: (Container)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Trophy_Idle {
  Layout: {
    trophyGroup: object;
  };

  BlockTypeByName: {
    trophy_1_copy_1: object;
    trophy_1_copy_copy: object;
  };

  flowData = raw.animations[0];
}

export abstract class Smoke_Animation {
  Layout: {
    smokeContainer: object;
  };

  BlockTypeByName: {
    FXPART_Race_Event_Smoke_Particles_Join_Screen: object;
  };

  flowData = raw.animations[1];
}

export abstract class Button_Idle {
  Layout: {
    joinButton: object;
  };

  BlockTypeByName: {
    New_tween: object;
    New_tween_copy: object;
    New_tween_copy_1: object;
    New_tween_copy_copy: object;
  };

  flowData = raw.animations[2];
}
